<template>
  <NotificationBar ref="notificationBar" />
  <div id="nav-bar-container">
    This is the Nav Bar
    <div 
      id="login-person"
      @click.stop="toggleUserModal()"
    >
      <div class="std-spacing">{{ (userName) ? userName : 'Login' }}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle std-spacing" viewBox="0 0 16 16">
        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
        <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
      </svg>
      <div
        id="user-modal"
        :class="{ grow: showUserModal}"
        @click.stop=""
      >
        <!-- USER IS ALREADY LOGGED IN -->
        <div v-if="!!userName">
          <div>
            <button @click="logoutUser()">Log Out</button>
          </div>
          <div>
            <!-- <button>Edit Account</button> -->
            <!-- <button>View Orders</button> -->
             <button @click="openAccountPage()" >Account</button>
          </div>
        </div>

        <!-- USER NEEDS TO LOG IN -->
         <div v-else>
          <input key='fla-user-email' name='fla-user-email' type="text" placeholder="email" v-model="userEmail">
          <input type="password" placeholder="password" v-model="pw">
          <div id="login-button-wrapper">
            <!-- <router-link to="/createUser" tag="button">Create User</router-link> -->
            <button @click="$router.push('createUser')">Create User</button>
            <button
              @click="userLogin"
              :disabled="!canSubmit"
            >
              Login
            </button>
          </div>
          
         </div>

      </div>
    </div>
  </div>
</template>

<script>

// GLOBALS
// --------------------
const API = process.env.VUE_APP_API_URL;
let NOTIFICATION;
// --------------------

import NotificationBar from './NotificationBar.vue';
import { ValidateEmail } from '../utils';


export default {
  name: 'NavBar',
  components: {
    NotificationBar,
  },
  data () { 
    return {
      userName: '',
      userEmail: '',
      pw: '',
      showUserModal: false,
      
    }
  },
  computed: {
    canSubmit() {
      return this.pw !== '' && ValidateEmail( this.userEmail );
    },

  },
  methods: {
    userModalToggle( val ) {
      this.showUserModal = val;
      // TODO: remove this method
    },

    toggleUserModal() {
      this.showUserModal = !this.showUserModal
    },

    userLogin() {
      const data = {
        email: this.userEmail,
        pw: this.pw
      };
      console.log(data)

      this.axios
        .post( API + '/api/user/login', data )
        .then( res => {
          console.log(res.data)
          const { userName } = res.data;
          if ( userName ) this.userName = userName;
          NOTIFICATION.showNotification( res.data );

          // reset input info - mm 080724: pretty sure this isn't needed anymore
          if ( res.data?.notification?.type !== 'error' ) {
            this.email = '';
            this.pw = '';
          }
        } )
        .catch( e => console.log(e) );

    }, 

    fetchUserName() {
      this.axios
        .get( API + '/api/user/fetchUser' )
        .then( res =>{
          const { userName } = res.data;
          this.userName = userName;
        } )
        .catch( e => console.log(e) );
    },

    logoutUser() {
      const deleteCookie = ( cookieName ) => {
        document.cookie = cookieName +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      };


      // clear any cookies that include FLA
      // TODO: probably should update this to just start with FLA
      const a = document.cookie
        .split(';')
        .map( x => x.split('=')[0] )
        .filter( x => x.includes('FLA') )
        .forEach( cookie => deleteCookie( cookie ) );

      // reset userName value
      this.userName = '';

      // force a notification
      NOTIFICATION.showNotification( { notification: {
        msg: 'User has been logged out.'
      } } );
    },

    openAccountPage() {
      const url = window.location.href;
      console.log(url)
      window.location.replace( url + 'userAccount')
    }


  },
  mounted() {
    NOTIFICATION = this.$refs.notificationBar;
    this.fetchUserName();
  }
}
</script>

<style scoped>

#nav-bar-container {
  display: flex;
  height: 3rem;
  background-color: rgb(220, 220, 220);
  border: 2px solid black;
  justify-content: space-evenly;
  align-items: center;
  box-sizing: border-box;
}

#user-modal {
  background-color: orange;
  position: absolute;
  width: 13rem;
  height: 0rem;
  transition: all .3s;
  top: 2rem;
  right: 0rem;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 10px;
  justify-content: space-around;
}

 #user-modal.grow {
  height: 5rem;
  border: 1px solid black;
 }

#login-person {
  background-color: orange;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
}

.std-spacing {
  padding: .25rem;
  margin: .15rem;
}

#login-button-wrapper {
  display: flex;
  justify-content: space-between;
}
#login-button-wrapper button {
  margin-left: .5rem;
  margin-right: .5rem;
}

button:not(:disabled) {
  cursor: pointer;
  margin: .25rem;
}

</style>